import React from "react";
import { statusMeta } from "../mock/mock";

const COLORS = {
  emerald: "bg-emerald-100 text-emerald-800 border-emerald-200",
  amber: "bg-amber-100 text-amber-800 border-amber-200",
  rose: "bg-rose-100 text-rose-800 border-rose-200",
  sky: "bg-sky-100 text-sky-800 border-sky-200",
};

export default function StatusBadge({ status, className = "" }) {
  const meta = statusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-600 border ${COLORS[meta.color]} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {meta.label}
    </span>
  );
}
